<!-- <mat-card  appearance="outlined"  *ngIf="authService.isProcessing()">
    <span>Authenticating</span><br />
    <mat-progress-bar mode="query"></mat-progress-bar>
 </mat-card>
<span *ngIf="homePage()">
    <router-outlet ></router-outlet>
</span>
<span *ngIf="errorPage()">
    <error-code
    code="401"
    [title]="'Unauthorized!'"
    [message]="'You do not have permission to access this site.'"
    [showHomeButton]=false
  ></error-code>
</span> -->

<router-outlet *ngIf="!isIframe"></router-outlet>
